// A temporary fix for https://github.com/bengourley/currency-symbol-map/issues/41
const currencySymbolMap = require('currency-symbol-map');
const getSymbolFromCurrency: (currency: string) => string = (currency: string) => {
  return currency.toUpperCase() === 'PEN' ? 'S/' : currencySymbolMap(currency);
};

export default getSymbolFromCurrency;
